<template>

  <table>
    <tr>
      <td align="right" class="pr-1">
        {{ $t('Evaluations') }}:
      </td>
      <td>
        <strong :class="scoreClass">{{  ratingEvaluation ? `${ratingEvaluation}%` : '-' }}</strong>
      </td>
    </tr>
    <tr>
      <td align="right" class="pr-1">
        {{ $t('Videos') }}:
      </td>
      <td>
        <strong>{{ ratingIntervideo ? `${ratingIntervideo}%` : '-' }}</strong>
      </td>
    </tr>
    <tr>
      <td align="right" class="pr-1">
        {{ $t('Tests') }}:
      </td>
      <td>
        <strong>{{ ratingQuestionnaire ? `${ratingQuestionnaire}%` : '-' }}</strong>
      </td>
    </tr>
  </table>

</template>

<script>
export default {
  name: 'CandidateRating',
  components: {
  },
  data () {
    return {
    }
  },
  computed: {
    candidate () {
      return this.$store.getters.getCandidate
    },
    avgs () {
      return this.candidate.avg_rating
    },
    ratingEvaluation () {
      return this.avgs && !isNaN(this.avgs.evaluation) ? this.avgs.evaluation : null
    },
    ratingIntervideo () {
      return this.avgs && !isNaN(this.avgs.intervideo) ? this.avgs.intervideo : null
    },
    ratingQuestionnaire () {
      return this.avgs && !isNaN(this.avgs.questionnaire) ? this.avgs.questionnaire : null
    },
    scoreClass () {
      if (this.ratingEvaluation === null) {
        return ''
      } else if (this.ratingEvaluation <= 25) {
        return 'text-danger'
      } else if (this.ratingEvaluation <= 50) {
        return 'text-warning'
      } else if (this.ratingEvaluation <= 75) {
        return 'text-primary'
      } else {
        return 'text-success'
      }
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Candidate/Header/CandidateRating.vue